import React, { useEffect, useState } from "react";
// import TiffViewer from './TifViewer';
import MyTiffViewer from "./TifViewer";
import { DisplayMsg } from "../../services/toastService";
import { downloadDocument } from "../../services/DocumentApi";
import { downloadFileFromJsonBlob } from "../../utils/helper";

const AttachImage = (props) => {
  const [imageUrl, setImageUrl] = useState("");

  const [showTif, setShowTif] = useState(false);

  useEffect(() => {
    if (props?.data.fileType === "image/tiff" || props?.data.fileType === "image/tiff") {
      setImageUrl(props.data?.imageData);
      setShowTif(true);
    } else {
      setShowTif(false);
      setImageUrl(props.data?.imageData);
    }
  }, [props]);


  const TriggerImage = () => {
    props.parentCallback(false);
  };

  const DownloadImage = async () => {
    const { filePath, fileName } = props.data || {};

    if (!filePath || !fileName) {
      DisplayMsg("2", "Invalid file information");
      return;
    }

    try {
      document.getElementById("loader").style.display = "block";
      const extension = fileName.split(".").pop();      
      const fullPath =
        `${filePath ?? ""}/${fileName ?? ""}`.toLowerCase();

      const response = await downloadDocument(
        fullPath,
        extension,
      );
      if (!response?.data) {
        DisplayMsg("2", "Failed to download file");
        return;
      }
      downloadFileFromJsonBlob(response.data, fileName);
      document.getElementById("loader").style.display = "none";
    } catch (e) {
      DisplayMsg("2", "File not downloaded");
    } finally {
      document.getElementById("loader").style.display = "none";
    }
  };

  return (
    <div className="overlay imageIndex">
      <div className="popup">
        <div className="popup__header">
          <div className="col-7 flex-center-end">
            <h3>Attached Image</h3>
          </div>
          <div className="col-5 flex justify-content-end">
            <button type="button" className="mr-2" onClick={() => DownloadImage()}>
              Download Image
            </button>
            <span
              className="close close position-sticky"
              role="button"
              onClick={() => TriggerImage(false)}
            >
              ×
            </span>
          </div>
        </div>
        <div className="content">
          <div className="popup__body imageIndex">
            <div id="AttachedImagePopUp_Container" className="panCont">
              <div
                id="Support_Ticket_Viewer_container"
                className="panCont dataFormPan"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
              >
                <div
                  id="pnlSupport_Ticket_Viewer"
                  style={{ marginTop: "20px", height: "440px", width : "100%" }}
                >
                  {showTif ? (
                    <MyTiffViewer data={imageUrl} />
                  ) : (
                    <img
                      id="imgTicketImage"
                      alt="HTML5 Icon"
                      src={`data:${props?.data?.fileType};base64,${imageUrl}`}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttachImage;
